export const DEPARTMENT_ID = process.env.REACT_APP_DEPARTMENT_ID;
export const CMS_REPORT_ENABLED = process.env.CMS_REPORT_ENABLED || false;